import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReport = () => import('./staff/crudReport')
const ViewStaffCrudReportSeller = () => import('./staff/crudReportSeller')
const ViewStaffDetailReport = () => import('./staff/detailReport')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReportsGeneralStaffDashboard',
  crudReport: 'ReportsGeneralStaffCrudReport',
  crudReportSeller: 'ReportsGeneralStaffCrudReportSeller',
  detailReport: 'ReportsGeneralStaffDetailReport',
}

const router =
  [
    {
      path: '/st/reports-general',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reporte general',
          }          
        },  
        {
          path: 'crud',
          name: VIEWS.crudReport,
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte general',
          }          
        },  
        {
          path: 'crud-seller',
          name: VIEWS.crudReportSeller,
          component: ViewStaffCrudReportSeller,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte general',
          }          

        },         
        {
          path: 'detail/:reportID/view',
          name: VIEWS.detailReport,
          component: ViewStaffDetailReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Detalle de reporte general',
          }                        
        },
      ]
    },

    {
      path: '/cu/reports-general',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reports-general',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
